export const PdfType = {
  ConstructionDayReport: 'construction-day-report',
  Document: 'document',
  HourOverview: 'hour-overview',
  Inspection: 'inspection',
} as const;
